/* eslint-disable comma-dangle */

export default {
  address: ['user-input', 'map', 'underground'],
  'about-object': [
    'common/cadastral-number',
    'housing-type',
    'rooms-count-daily',
    'urban-total-area',
    'layout-photo',
    'floor',
    'all-rooms-area',
    'beds-count',
    'living-area',
    'kitchen-area',
    'visual-divider',
    'loggias-count',
    'balconies-count',
    'window-view-type',
    'visual-divider',
    'separate-wcs-count',
    'combined-wcs-count',
    'visual-divider',
    'repair-type',
    'in-flat-rent',
  ],
  'about-building': [
    'name-and-year',
    'material-type-and-series',
    'ceiling-height',
    'passenger-lifts',
    'cargo-lifts',
    'in-house',
    'parking',
  ],
  'price-and-deal-terms': ['price-rent-daily', 'bargain-daily', 'deposit', 'self-employed'],
};
